<template>
  <sec-section>
    <sec-section-heading :eyebrow="incidents.eyebrow" :title="incidents.title" />
    <sec-incident-list :items="incidents.items" :source-label="incidents.sourceLabel" />
    <p class="m500 sec-body" data-reveal>{{ incidents.closing }}</p>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecIncidentList from '@/components/security/ui/SecIncidentList.vue';
import { HOME } from '@/content/security/home';

const incidents = HOME.incidents;
</script>
